import { fetchApiData } from "../../utils/apiUtils";
import { ENDPOINT } from "../../constants/api";
import * as paymentSlice from "../slices/payment.slice";

export const getBankCompany = () => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.BLANK}/credit-card-type/list`,
    dispatch,
  });
  if (data) {
    dispatch(paymentSlice.clearBankCompany());
    dispatch(paymentSlice.setBankCompany(data));
  }
};

export const getPaymentSetting =
  (businessSlug, branchId) => async (dispatch) => {
    const data = await fetchApiData({
      method: "get",
      endpoint: `${ENDPOINT.POS.replace(
        "{businessSlug}",
        businessSlug
      )}/branch-payment-setting`,
      params: {
        branchId,
      },
      dispatch,
    });
    if (data) {
      dispatch(paymentSlice.clearPaymentSetting());
      dispatch(paymentSlice.setPaymentSetting(data));
    }
  };

export const getBranchTags = (businessSlug, branchId) => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.POS.replace(
      "{businessSlug}",
      businessSlug
    )}/branch-tag/all/list`,
    params: {
      branchId,
    },
    dispatch,
  });
  if (data) {
    return data;
  }
};
